import React from "react"
import Modal from "@components/modal"
import BlockHero from "@components/common/blockHero"
import ModalActuacionContent from "@components/common/modalActuacionContent"
import Image from "@images/actuacion/modal/actuamos/actuamos.png"
import BlockNumber from "@components/common/blockNumber"
import ChangeModalBtn from "@components/common/changePageBtn"

import Icon16 from "@images/icons/es/cert-icon-16.png"

const Actuamos = () => {
  return (
    <Modal title="A NOSA ACTUACIÓN EN 2020">
      <div className="mainModal-container">
        <div className="element actuamos">
          <BlockHero>
            <div className="title">Actuamos</div>
            <div className="subtitle">con transparencia e responsabilidade</div>
            <div className="description">
              A anticipación de riscos, a capacidade de reacción e a xestión
              ética marcaron o modelo de actuación da Entidade ante a crise
              sanitaria. A comunicación cos grupos de interese estivo sempre
              marcada pola transparencia e continuidade.
            </div>
          </BlockHero>
        </div>
        <div className="element actuamos">
          <ModalActuacionContent>
            <div className="row">
              <div className="image">
                <img src={Image} alt=""></img>
              </div>
            </div>
            <div className="row">
              <div className="container">
                <div className="sideA">
                  <div className="title">
                    Supervisión constante dos riscos asociados á pandemia
                  </div>
                  <div className="subtitle">
                    Pola natureza da actividade de Mutua Universal, a pandemia
                    de coronavirus podía impactar na Entidade a niveis moi
                    diversos: sostibilidade económica, prestación de servizos
                    asistenciais e de xestión, relación coa administración ou
                    desempeño do cadro de persoal. Co obxectivo de anticipar os
                    riscos, desenvolveuse un plan de continxencia específico.
                  </div>
                  <div className="list">
                    <div className="title">
                      Entre as accións realizadas destacan:
                    </div>
                    <ul>
                      <li>
                        Constitución dun Comité de Crise Coronavirus formado
                        polos principais cargos de decisión da Entidade.
                      </li>
                      <li>
                        Elaboración dun “Mapa de Riscos COVID-19” para
                        identificar, avaliar, xestionar e controlar os
                        principais riscos relacionados coa pandemia.
                      </li>
                      <li>
                        Implantación dun procedemento extraordinario para o
                        control e seguimento dos cambios normativos derivados da
                        COVID-19.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="sideB">
                  <div className="number">
                    <span>+2,7M</span>
                    <span>
                      de impactos en comunicacións externas cun seguimento
                      constante das accións desenvolvidas para facer fronte á
                      pandemia e medidas de prevención
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="title">ODS DE IMPACTO DIRECTO</div>
              <div className="icons">
                <img src={Icon16} alt=""></img>
              </div>
            </div>
            <div className="row">
              <div className="container">
                <div className="side">
                  <div className="title">
                    Transparencia na comunicación co cadro de persoal e outros
                    grupos de interese
                  </div>
                  <div className="description">
                    De acordo co principio de xestión ética e transparente que
                    rexe o seu modelo de goberno, a Entidade mantivo unha
                    política de máxima transparencia na comunicación cos
                    profesionais e outros grupos de interese sobre a evolución
                    da crise, os cambios normativos e as medidas tomadas pola
                    organización.
                  </div>
                </div>
                <div className="side">
                  <div className="title">COMUNICACIÓNS INTERNAS</div>
                  <BlockNumber
                    topText=""
                    num="99"
                    bottomText="comunicados enviados"
                  />
                  <div className="midTitle">PORTAL DO EMPREGADO</div>
                  <BlockNumber
                    topText=""
                    num="62"
                    bottomText="novas publicadas"
                  />
                  <BlockNumber
                    topText=""
                    num="12.297"
                    bottomText="páxinas únicas vistas"
                  />
                  <div className="bigText">
                    <BlockNumber
                      normal={true}
                      topText=""
                      num="393"
                      bottomText="subscritores ao servizo de prensa (<i>clipping</i>)"
                    />
                  </div>
                </div>
                <div className="side">
                  <div className="title">COMUNICACIÓNS EXTERNAS</div>
                  <BlockNumber
                    topText=""
                    num="719"
                    bottomText="envíos Boletín Universal"
                  />
                  <BlockNumber
                    topText=""
                    num="2,8 M"
                    bottomText="de impactos"
                  />
                  <div className="bigText">
                    <BlockNumber
                      topText=""
                      num="113"
                      bottomText="envíos a empresas e asesores"
                    />
                  </div>
                  <BlockNumber
                    topText=""
                    num="2,7 M"
                    bottomText="de impactos"
                  />
                </div>
                <div className="side">
                  <div className="title">
                    RELACIÓN COS MEDIOS DE COMUNICACIÓN
                  </div>
                  <div className="bigText">
                    <BlockNumber
                      topText=""
                      num="15"
                      bottomText="notas de prensa enviadas"
                    />
                  </div>
                  <BlockNumber
                    topText=""
                    num="74"
                    bottomText="impactos directos"
                  />
                </div>
              </div>
            </div>
          </ModalActuacionContent>
        </div>
        <div className="changeBtn">
          <ChangeModalBtn />
        </div>
      </div>
    </Modal>
  )
}

export default Actuamos
